export const appConfig = window.config;
export const appConfigModule = angular
  .module('Q.config.app-config', [])
  .run(function ($rootScope) {
    $rootScope.appConfig = appConfig;
  });
